import {
  Avatar,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  makeStyles,
} from "@material-ui/core";

import FileIcon from "@material-ui/icons/AttachFileRounded";
import React from "react";
import { get } from "lodash";
import { useTranslate } from "ra-core";

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
    "text-overflow": "ellipsis",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    whiteSpace: "break-spaces",
  },
}));
const FileField = ({ record, minWidth = 150, maxRows = 3 }) => {
  const href = get(record, "file.path");
  const label = get(record, "file.name");
  const classes = useStyles();
  return (
    <Link
      href={href}
      target="_blank"
      variant="body2"
      className={classes.root}
      style={{
        minWidth,
        WebkitLineClamp: maxRows,
      }}
    >
      {label}
    </Link>
  );
};

const DocsField = (props) => {
  const items = get(props, "record." + props.source, []);
  const translate = useTranslate();
  if (items.length === 0) {
    return <Typography variant="body2">{translate("ra.none")}</Typography>;
  }
  return (
    <List dense>
      {items.map((record) => (
        <ListItem key={record.id} disableGutters>
          <ListItemAvatar>
            <Avatar>
              <FileIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={<FileField record={record} />} />
        </ListItem>
      ))}
    </List>
  );
};
export default DocsField;
